import { ApiError } from './api';

export function roomCheckErrorMessage(error: unknown): string {
  if (!navigator.onLine) return 'Нет подключения к интернету. Подключитесь к сети и повторите попытку.';
  if (error instanceof ApiError && error.status >= 500) {
    return 'Сервис встреч временно недоступен. Повторите попытку через минуту.';
  }
  return 'Не удалось проверить встречу. Проверьте интернет и повторите попытку.';
}

export function joinErrorMessage(error: unknown): string {
  if (!navigator.onLine) return 'Нет подключения к интернету. Подключитесь к сети и попробуйте снова.';
  if (error instanceof ApiError) {
    if (error.code === 'invalid_name') return 'Введите имя длиной до 40 символов.';
    if (error.status === 404) return 'Встреча не найдена или уже удалена.';
    if (error.status === 429) return 'Слишком много попыток входа. Подождите несколько минут и попробуйте снова.';
    if (error.status >= 500) return 'Сервис встреч временно недоступен. Попробуйте ещё раз через минуту.';
  }
  return 'Не удалось получить доступ ко встрече. Проверьте интернет и попробуйте снова.';
}

export function createRoomErrorMessage(error: unknown): string {
  if (!navigator.onLine) return 'Нет подключения к интернету. Подключитесь к сети и попробуйте снова.';
  if (error instanceof ApiError && error.status === 429) {
    return 'Слишком много созданных встреч. Попробуйте снова немного позже.';
  }
  if (error instanceof ApiError && error.status >= 500) {
    return 'Сервис встреч временно недоступен. Попробуйте ещё раз через минуту.';
  }
  return 'Не удалось создать встречу. Проверьте интернет и попробуйте снова.';
}

export function endRoomErrorMessage(error: unknown): string {
  if (!navigator.onLine) return 'Нет подключения к интернету. Встреча не завершена.';
  if (error instanceof ApiError && error.status === 403) {
    return 'Не удалось подтвердить права организатора. Обновите страницу и попробуйте снова.';
  }
  if (error instanceof ApiError && error.status === 404) return 'Встреча уже завершена.';
  return 'Не удалось завершить встречу для всех. Попробуйте ещё раз.';
}
